import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=cf7f7e6c&scoped=true&"
import script from "./SocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&id=cf7f7e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7f7e6c",
  null
  
)

export default component.exports